import { render } from "./MFITTBookingSelectSeatType.vue?vue&type=template&id=7a554b56&scoped=true"
import script from "./MFITTBookingSelectSeatType.vue?vue&type=script&lang=js"
export * from "./MFITTBookingSelectSeatType.vue?vue&type=script&lang=js"

import "./MFITTBookingSelectSeatType.vue?vue&type=style&index=0&id=7a554b56&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7a554b56"

export default script